import * as React from "react";
import { Utility, ReactHelper } from "../../utils";
import { WrapperLess } from "../generic";
import { Link } from "react-router-dom";

interface OwnProps {
    avatar?: string;
    email?: string;
    emailAsLink?: boolean;
    link?: string;
    name: string;
    title?: string;
    onDelete?: () => void;
}

export const PersonSearchListItem: React.SFC<OwnProps> = (props) => {
    const name = props.name;
    let nameWithDegrees: string | JSX.Element = !props.title
        ? name
        : Utility.joinSkipEmpty([name, props.title], ", ");

    const email = props.email
        ? <WrapperLess><br />{
            props.emailAsLink
                ? <a className="mute" href={`mailto:${props.email}`}>{props.email}</a>
                : <span className="mute">{props.email}</span>}
        </WrapperLess>
        : null;

    if (props.link) {
        if (props.link.indexOf("/") === 0)
            nameWithDegrees = <Link to={props.link}>{nameWithDegrees}</Link>;
        else
            nameWithDegrees = <a href={props.link}>{nameWithDegrees}</a>;
    }

    let avatar = props.avatar;
    if (avatar && avatar.indexOf("asrs.org") > -1)
        avatar += "/image-custom;ratio_crop$0,0;max$50,50.ImageHandler";

    const deleteBtn = typeof props.onDelete === "function"
        ? <WrapperLess> (<a href="#" onClick={(e) => { ReactHelper.emptyClick(e); (props.onDelete as any)(); }}>Delete</a>)</WrapperLess>
        : null;

    return <WrapperLess>
        <img alt="" src={avatar} style={{ width: "50px" }} /> {nameWithDegrees}{deleteBtn}{email}
    </WrapperLess>;
};



// WEBPACK FOOTER //
// ./src/components/reusable/PersonSearchListItem.tsx